import type { taches as Fr } from '../fr/taches';

/** « taches » in English — typed on the French: a missing sentence does not compile. */
export const taches: typeof Fr = {
  bonjour: (nom) => `hello ${nom}`,
  miseEnService: (faites, total) => `Getting started — ${faites} of ${total}`,
  demandesRefusees: (n) => `${n} ${n === 1 ? 'request' : 'requests'} turned down for lack of a vehicle over 30 days — about `,
  enRetard: (n) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} overdue`,
  fileDuJour: (departs, retours) => `Today's queue — ${departs} ${departs === 1 ? 'check-out' : 'check-outs'}, ${retours} ${retours === 1 ? 'return' : 'returns'}`,
  champ: (entite, champ) => `${entite} — field “${champ}”`,
  demandeLe: (motif, date) => `${motif} · requested on ${date}`,
  aFaireMaintenant: 'To do now',
  aujourdHui: 'Today',
  localeDate: 'en-GB',
  mesVoitures: 'My vehicles',
  voituresLibres: 'Available vehicles',
  nouvelleLocation: 'New rental',
  voirListe: 'Show the list',
  reduire: 'Collapse',
  mesIntro: 'What still needs to be filled in for the figures to be accurate. This card will disappear on its own.',
  indispensable: 'Required',
  yAller: 'Go',
  tresoDisponible: 'Cash actually available',
  soldeCaisse: 'Cash register balance ',
  moinsPrestations: '− future services already collected ',
  moinsCautions: '− deposits held ',
  voirDetail: 'View details',
  tauxUtilisation: 'Utilisation rate',
  tauxDetail: 'target 75–85 % · see my vehicles',
  revenuParVoiture: 'Revenue per vehicle / day',
  revenuDetail: 'see details per vehicle',
  prixMoyen: 'Average daily rate',
  prixDetail: 'actually charged',
  caMois: 'Revenue this month',
  caDetail: 'see the forecast',
  diagnostic: 'Diagnosis',
  argentInvisible: 'The money you are not seeing',
  caPerdu: ' of lost revenue.',
  signalezLes: 'Report them to the manager, do not decide alone.',
  enPriorite: 'Handle these first.',
  toutAJour: 'All up to date',
  aucunDepart: 'No check-out or return to handle for now.',
  signaler: 'Report to manager',
  faireDepart: 'Do the check-out',
  faireRetour: 'Do the check-in',
  attenteResponsable: 'Waiting for the manager',
  traiter: 'Handle',
  soldesAEncaisser: 'Balances to collect',
  thContrat: 'Agreement',
  thClient: 'Customer',
  thSoldeDu: 'Balance due',
  encaisser: 'Take payment',
  aSurveiller: 'To watch',
  pasAVous: 'What is not yours',
  pasAVousTexte: 'These amounts are in the cash register but are not available: they match services you have not delivered yet, or money that belongs to your customers.',
  prestationsFutures: 'Future services already collected',
  thLocation: 'Rental',
  thPeriode: 'Period',
  thNonLivre: 'Not delivered',
  cautionsDetenues: 'Deposits held',
  cautionsTexte: ' — this is your customers\' money, it will have to be returned to them.',
};
